import classNames from 'classnames';
import { t } from 'ttag';
import CustomButton from '../customButton';
import { illustrationIcon, nodataIcon, notFoundIcon } from './assets';
import type { NoDataComponentProps } from './types';
import './noDataComponent.scss';

const MESSAGE_ARTIFACT_REPORT =
  'This report could not be generated due to all data being artifact. Please ensure you are checking ECG connection when starting a study';

/**
 * Empty-state block shown when a list, report or search yields no rows. Picks the illustration, not-found or generic no-data icon from the artifact-report message and the isSearching flag, falls back to translated default text when no message is passed, and when hasTryButton is set during a search also shows the searched study FID and a Try a different keyword button.
 *
 * @param props - Optional message and icon override, the searching and try-button flags, searched study FID and the retry handler.
 * @returns The rendered empty-state element.
 */
const NoDataComponent = (props: NoDataComponentProps) => (
  <div className={classNames('no-data-container', props.className)}>
    {props.icon ? (
      props.icon
    ) : (
      <img
        className="no-data__icon"
        src={
          props.message === MESSAGE_ARTIFACT_REPORT
            ? illustrationIcon
            : props.isSearching
              ? notFoundIcon
              : nodataIcon
        }
        alt={t`No data icon`}
      />
    )}
    <div className="no-data__text">
      <div>
        {props.message
          ? props.message
          : props.isSearching
            ? props.hasTryButton
              ? t`We couldn't find any events matching`
              : t`No result found`
            : t`There is no data to display`}
      </div>
      {props.isSearching && props.hasTryButton && <div>{`"${props.studyFid}"`}</div>}
    </div>
    {props.isSearching && props.hasTryButton && (
      <CustomButton id="try-btn" className="try-btn" onClick={props.onClickTry} size="small">
        {t`Try a different keyword`}
      </CustomButton>
    )}
  </div>
);

export default NoDataComponent;
